/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ALL_ROUTES, COMMON, API_CONSTANTS, SYNC_SERVICE } from '../../global/Constants';
import './krishak.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import Select from 'react-select';
import AddNewImages from '../common/AddNewImages';
import GpsCoordinates from '../common/GpsCoordinates';
import ApiServices from '../../providers/ApiServices';
import { ActivityStatusType } from '../../global/Enum';
import SyncServices from '../../providers/SyncServices';
import DataProvider from '../../providers/DataProvider';
import AuthService from '../../providers/AuthService';
import SyncLoader from '../common/loader/SyncLoader';

class AddFarmer extends Component {
    constructor(props) {
        super(props);
        this.localKrishakCount = 0;
        this.goBack = this.goBack.bind(this);
        this.state = {
            isLoading: false,
            data: {},
            isFarmer: false,
            seasonData: [],
            subActivityData: [],
            retailerData: [],
            selectedSeason: null,
            selectedSubActivity: null,
            selectedRetailer: null,
            activity_images: [],
            remarks: "",
            krishakInfo: {},
            latitude: null,
            longitude: null,
            krishakId: 0,
            deletedImages: []
        }
    }

    async componentDidMount() {

        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            await DataProvider.getInstance().fetchMasterData();
            this.checkOfflineData();
            if (this.props.location.state) {
                let activity = this.props.location.state.data;
                const krishakInfo = this.props.location.state.krishakInfo;
                if (krishakInfo) {
                    activity.krishak_id = krishakInfo?.krishak_id;
                    activity.temp_krishak_id = krishakInfo?.temp_krishak_id;
                    activity.temp_krishak_phone = krishakInfo?.phone;
                }

                if (activity?.retailer_id > 0) {
                    const retailerInfo = this.props.location.state.retailerInfo;
                    if (retailerInfo) {
                        this.getRetailerById(retailerInfo.retailer_id);
                    }
                    this.getRetailers();
                }
                this.setState({
                    data: activity,
                    isFarmer: this.props.location.state.isFarmer,
                    krishakInfo: krishakInfo,
                }, () => {
                    this.getSeasons();

                    if (this.state.data?.activity_status_id === ActivityStatusType.TO_RESUBMIT ||
                        this.state.data?.activity_status_id === ActivityStatusType.PENDING_REVIEW) {
                        // With API
                        //this.getActivityById(this.state.data);

                        // Offline
                        this.getActivityById(activity.key);
                        this.getKrishakById(activity.krishak_id);
                    }
                });
            }

        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    checkOfflineData = () => {
        SyncServices.getLocalKrishakCount().then(krishakCount => {
            if (krishakCount > 0) {
                this.localKrishakCount = krishakCount;
            }
        });
    }

    getRetailers = () => {
        const retailers = DataProvider.getInstance().getRetailers();
        if (retailers) {
            const retailerArray = retailers?.map(({ retailer_id: value, retailer_name: label, ...rest }) => ({ value, label, ...rest }));
            Utilities.LogPrint("Retailers:-", retailerArray);
            this.setState({
                retailerData: retailerArray
            })
        }
    }

    getSeasons() {
        // const seasons = DataProvider.getInstance().getSeasons();
        // Utilities.LogPrint("getSeasons123", seasons);
        // if (seasons !== null) {
        //     this.setState({ seasonData: seasons })
        // }

        //TODO As Per New Change
        const { data } = this.state;
        const seasons = DataProvider.getInstance().getCropSeasonSubActivities(data.crop_id, data.activity_type_id);
        //Utilities.LogPrint("getSeasons123", items);
        if (seasons !== null) {
            this.setState({ seasonData: seasons })
        }
    }

    getSubActivities(activityTypeId, seasonId, cropId) {
        const subActivities = DataProvider.getInstance().getSubActivities(activityTypeId, seasonId, cropId);
        Utilities.LogPrint("subActivities", subActivities);
        if (subActivities !== null && subActivities.length > 0) {
            const subActivityArray = subActivities.map(({ sub_activity_id: value, sub_activity_name: label, ...rest }) => ({ value, label, ...rest }));
            this.setState({
                subActivityData: subActivityArray,
            })
        }
    }


    //Offline
    getActivityById = (activityId) => {
        this.setState({ isLoading: true });

        SyncServices.getActivityById("key", activityId).then(activity => {
            Utilities.LogPrint("getActivityById ===========", activity);
            const data = activity?.data;
            if (data !== null) {
                this.setState({
                    //data: item,
                    krishakId: data?.krishak_id,
                    selectedSeason: data?.season_id,
                    selectedSubActivity: data?.sub_activity_id,
                    selectedRetailer: data?.retailer_id,
                    remarks: data?.remark,
                    activity_images: data?.activity_images,
                    isLoading: false
                }, () => {
                    this.getSubActivitiesById(data?.sub_activity_id);
                    this.getRetailerById(data?.retailer_id);
                })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    getSubActivitiesById = (subActivityId) => {
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_SUB_ACTIVITY, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data) {
                const subActivityArray = data?.map(({ sub_activity_id: value, sub_activity_name: label, ...rest }) => ({ value, label, ...rest }));
                let subActivity = subActivityArray.find(item => item.value === subActivityId);
                if (subActivity != null) {
                    this.setState({ selectedSubActivity: subActivity })
                }
            }
        });
    }

    getRetailerById = (retailerId) => {
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_RETAILER, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data) {
                const retailerArray = data?.map(({ retailer_id: value, retailer_name: label, ...rest }) => ({ value, label, ...rest }));
                let retailer = retailerArray.find(item => item.value === retailerId);
                if (retailer != null) {
                    this.setState({ selectedRetailer: retailer })
                }
            }
        });
    }

    goBack() {
        this.props.history.goBack();
    }


    viewKrishakInfo = () => {
        const { krishakInfo } = this.state;
        Utilities.LogPrint("krishakInfo ==", krishakInfo);
        this.props.history.push({
            pathname: ALL_ROUTES.KRISHAK_INFO_ROUTE,
            state: { krishak_id: krishakInfo.krishak_id === 0 ? krishakInfo.temp_krishak_id : krishakInfo.krishak_id }
            //state: { krishak_id: this.state.krishakInfo.krishak_id }
        });

        // this.props.history.push({
        //     pathname: ALL_ROUTES.KRISHAK_INFO_ROUTE,
        //     state: { krishak_id: this.state.krishakId }
        // });
    }

    getKrishakById = (krishak_id) => {
        SyncServices.findKrishakFromDatabase("krishak_id", String(krishak_id)).then(data => {
            if (data) {
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
                    const krishakInfo = data;
                    this.setState({
                        krishakInfo
                    });
                }
            }
        });
    }

    handleSubActivityChange = selectedSubActivity => {
        this.setState({ selectedSubActivity });
    };

    handleRetailerChange = selectedRetailer => {
        //const { krishakInfo } = this.state;
        //krishakInfo['phone'] = selectedRetailer.phone;
        this.setState({ selectedRetailer });
    };

    handleAddImages = (images) => {
        Utilities.LogPrint("Images", images);
        this.setState({ activity_images: images });
    }

    handleDeleteImages = (deletedImage) => {
        Utilities.LogPrint("Images Deleted", deletedImage);
        var deletedImagesArray = this.state.deletedImages.slice();
        deletedImagesArray.push(deletedImage);
        this.setState({ deletedImages: deletedImagesArray }, () => {
            Utilities.LogPrint("Images Deleted", this.state.deletedImages);
        });
    }

    getCoordinates = (latLng) => {
        this.setState({
            latitude: latLng.latitude,
            longitude: latLng.longitude
        })
    }

    handleSeason = selectedSeason => {
        //const { data } = this.state;
        this.setState({
            selectedSeason,
            subActivityData: [],
            selectedSubActivity: null
        }, () => {
            //this.getSubActivities(data.activity_type_id, selectedSeason, data.crop_id);

            const subActivities = selectedSeason?.sub_activity ?? [];
            if (subActivities !== null && subActivities.length > 0) {
                const subActivityArray = subActivities.map(({ sub_activity_id: value, sub_activity_name: label, ...rest }) => ({ value, label, ...rest }));
                this.setState({
                    subActivityData: subActivityArray,
                })
            }
        });
    };

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }


    handleSubmitButton = () => {

        const { isFarmer, data, selectedSeason, selectedSubActivity, selectedRetailer, latitude, longitude, remarks, activity_images, deletedImages } = this.state;

        const session = AuthService.getSession();
        const isTMLogin = session?.user.role_id === 3 ? true : false;

        //For Offline
        let dataObject = {
            key: data?.key,
            activity_id: data.activity_id,
            activity_type_id: data?.activity_type_id,
            activity_status_id: isTMLogin ? ActivityStatusType.COMPLETED : ActivityStatusType.PENDING_REVIEW,
            krishak_id: data?.krishak_id,
            temp_krishak_id: data?.temp_krishak_id,
            temp_krishak_phone: data.temp_krishak_phone,
            season_id: selectedSeason?.season_id,
            sub_activity_id: selectedSubActivity?.value,
            latitude: latitude,
            longitude: longitude,
            address: "",
            remark: remarks,
            retailer_id: !isFarmer ? selectedRetailer.value : 0,
            activity_images: activity_images,
            deletedImages: deletedImages
        }
        SyncServices.editActivity(dataObject, "false");
        //this.goBack();

        // If User Online
        if (Utilities.isNetworkConnected() && data?.activity_id > 0 && this.localKrishakCount === 0) {

            // For Images
            let activity_images_array = [];
            let activity_images = [];
            for (let i = 0; i < dataObject?.activity_images?.length; i++) {
                const objImage = dataObject?.activity_images[i];
                if (objImage.image_id === 0) {
                    let obj = {
                        temp_image_id: objImage.temp_image_id,
                        name: objImage.name
                    }
                    activity_images_array.push(obj);
                    activity_images.push(objImage.file);
                }
            }

            if (deletedImages.length > 0) {
                for (let i = 0; i < deletedImages?.length; i++) {
                    const objImage = deletedImages[i];
                    let obj = {
                        image_id: objImage.image_id,
                        isDeleted: objImage.isDeleted
                    }
                    activity_images_array.push(obj);
                }
            }

            const formData = new FormData();
            formData.append("activity_id", data.activity_id);
            formData.append("krishak_id", dataObject.krishak_id);
            formData.append("season_id", dataObject.season_id);
            formData.append("sub_activity_id", dataObject.sub_activity_id);
            formData.append("latitude", dataObject.latitude);
            formData.append("longitude", dataObject.longitude);
            formData.append("remark", dataObject.remark);
            formData.append("activity_status_id", dataObject.activity_status_id);
            if (activity_images_array.length > 0) {
                formData.append("activity_images_array", JSON.stringify(activity_images_array));
            }

            if (!isFarmer) {
                formData.append("retailer_id", dataObject.retailer_id);
            }

            if (activity_images.length > 0) {
                for (var i = 0; i < activity_images.length; i++) {
                    formData.append("activity_image", activity_images[i]);
                }
            }
            this.setState({ isLoading: true });
            try {
                ApiServices.editActivity(formData)
                    .then(async response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            const data = response.data;
                            if (data != null) {
                                const activity_images = data?.activity_images;
                                SyncServices.getActivityById("key", dataObject.key).then(activity => {
                                    let activityObj = activity;
                                    activityObj.is_synced = "true";
                                    activityObj.data.address = data?.address;
                                    activityObj.data.deletedImages = [];

                                    if (activity_images) {
                                        //let images = activityObj?.data?.activity_image;
                                        activityObj?.data?.activity_images.forEach((element, index) => {
                                            if (element.image_id === 0) {
                                                const image = activity_images?.find(item => item.temp_image_id === element.temp_image_id);
                                                if (image) {
                                                    element.imageId = image.image_id;
                                                    element.image_url = image.image_url;
                                                    element.file = "";
                                                }
                                            }
                                        });
                                        SyncServices.editActivityWithServer(activityObj, "true");
                                        this.goBack();
                                    }
                                });
                            }
                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            } else {
                                toast.info(response.message);
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        } else {
            this.goBack();
        }
    }

    //DELETE IMAGE API CALL FOR INDIVIUDALVISIT & SAMPLE DISTRIBUTION EDIT PART 
    deleteActivityImageApi = (item) => {
        var params = JSON.stringify({
            activity_image_id: item.activity_image_id,
        });
        try {
            ApiServices.deleteActivityImage(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("deleteActivityImage", response.message);
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("deleteActivityImage-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("deleteActivityImage-error", error);
        }
    }

    isFormValid() {
        const { isFarmer, selectedRetailer, selectedSeason, selectedSubActivity, latitude, longitude } = this.state;
        if (isFarmer) {
            return selectedSeason === null || selectedSubActivity === null || latitude === null || longitude === null;
        }
        else {
            return selectedRetailer === null || selectedSeason === null || selectedSubActivity === null || latitude === null || longitude === null;
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, data, isFarmer, seasonData, subActivityData, retailerData, selectedSubActivity, selectedRetailer, krishakInfo, remarks, selectedSeason, activity_images } = this.state;
        const { isSyncLoading, tableName } = this.state;
        const seasonLists = seasonData?.map((item, i) => {
            if (selectedSeason === item.season_id) {
                return (
                    <div className="radiobox-container radiobox-w-50" key={i}>
                        <input type="radio" name="radio1" checked onClick={() => this.handleSeason(item)} onChange={() => this.changeHandler} />
                        <span className="checkmark w-250">{item.season_name}</span>
                    </div>
                )
            } else {
                return (
                    <div className="radiobox-container radiobox-w-50" key={i}>
                        <input type="radio" name="radio1" onClick={() => this.handleSeason(item)} />
                        <span className="checkmark w-250">{item.season_name}</span>
                    </div>
                )
            }
        });

        let getKrishakPhoneNo = "+91 - " + krishakInfo?.phone;
        let selectedRetailerPhoneNo = selectedRetailer ? "+91 - " + selectedRetailer?.phone : "Phone Number";

        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />

                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="activity-info-box yellow-activity text-white mb-3">
                                <span>{data.activity_tag}</span>
                                <h5>{data.activity_type_name}</h5>
                                <span>{data.crop_name + ", " + data.hybrid_name + " | " + data.village_name}</span>
                            </div>
                        </div>
                    </div>

                    <div className="individual-visit-farmer">
                        {/* Input Farmer and Mobile Number */}
                        <div className="row">
                            {isFarmer ?
                                <div className="col-12 col-md-5 col-lg-4">
                                    <div className="form-group mb-md-0">
                                        <input type="text" className="form-control max-w-360" placeholder="Farmer Name" value={krishakInfo?.name} disabled />
                                    </div>
                                </div>
                                :
                                <div className="col-lg-4 col-md-5">
                                    <div className="form-group mb-md-0">
                                        <Select className="mb-3 max-w-360"
                                            value={selectedRetailer}
                                            onChange={this.handleRetailerChange}
                                            options={retailerData}
                                            placeholder="Select Retailer Name"
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                            }
                            <div className="col-12 col-md-5 col-lg-4">
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="" value={isFarmer ? getKrishakPhoneNo : selectedRetailerPhoneNo} disabled />
                                </div>
                            </div>

                        </div>

                        {isFarmer ?
                            <div className="row">
                                <div className="col-12 col-md-5 col-lg-4">
                                    <a className="d-flex align-items-center my-3" onClick={this.viewKrishakInfo}>
                                        {COMMON.VIEW_DETAILED_FARMER_INFORMATION} <i className="customic ic-info-black ml-auto"></i>
                                    </a>
                                </div>
                            </div>
                            : null}

                        {/* Stage of Visit */}
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group mb-0">
                                    <label className="font-weight-medium mt-2">Stage of Visit</label>
                                    <div className="d-flex flex-wrap radiobox-container-row">
                                        {seasonLists}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sub Activity */}
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="form-group">
                                    <label className="font-weight-medium mt-2">Sub Activity</label>
                                    <Select className="mb-3 max-w-360"
                                        value={selectedSubActivity}
                                        onChange={this.handleSubActivityChange}
                                        options={subActivityData}
                                        placeholder="Select any one"
                                        isClearable={true}
                                    />

                                </div>
                            </div>
                        </div>

                        {/* Remarks */}
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="font-weight-medium  mt-2">Remarks<span className="font-weight-normal">(if any)</span></label>
                                    <textarea className="form-control" rows="6"
                                        name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                </div>
                            </div>
                        </div>


                        {/* Add Images */}
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <AddImages imagePaths={images} handleAddImages={this.handleAddImages} deleteActivityImageApi={this.deleteActivityImageApi} /> */}
                                <AddNewImages
                                    handleAddImages={this.handleAddImages}
                                    images={activity_images}
                                    handleDeleteImages={this.handleDeleteImages} />
                            </div>
                        </div>

                        {/* GPS Co-ordinates */}
                        <GpsCoordinates getCoordinates={this.getCoordinates} />

                        <div className="row">
                            <div className="col-12 d-flex button-grp-bottom">
                                <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn" onClick={() => { this.goBack() }}>{COMMON.CANCEL}</button>
                                <button className="btn btn-primary w-50" onClick={this.handleSubmitButton} disabled={this.isFormValid()}>{COMMON.SUBMIT}</button>
                            </div>
                        </div>

                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
            </div>
        )
    }
}
export default withRouter(AddFarmer)